<template>
  <svg :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.0026 13.6693C3.3206 13.6693 0.335938 10.6846 0.335938 7.0026C0.335938 3.3206 3.3206 0.335938 7.0026 0.335938C10.6846 0.335938 13.6693 3.3206 13.6693 7.0026C13.6693 10.6846 10.6846 13.6693 7.0026 13.6693ZM6.33594 6.33594H3.66927V7.66927H6.33594V10.3359H7.66927V7.66927H10.3359V6.33594H7.66927V3.66927H6.33594V6.33594Z" :fill="color" :fill-opacity="opacity"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconSolidPlus',
  components: {
  },
  props: {
    color: String,
    height: String,
    width: String,
    opacity: String
  }
})
export default class extends Vue {
  @Prop({ default: '#5138EE' }) color!: string;
  @Prop({ default: '14' }) height!: string;
  @Prop({ default: '14' }) width!: string;
  @Prop({ default: '1' }) opacity!: string;
}
</script>

<style scoped>
</style>
